<template>
  <div ref="container" class="browser-content" style="overflow: auto">
    <div v-if="content.length === 0" class="message">
      <div class="message-body">{{ $t("No text found.") }}</div>
    </div>
    <span style="font-style: italic;"
      >{{$t('Please note that only the first page has been scanned. In most cases, however, the land register pages for one person consist of 4 or 6 pages. You can order the scans for the missing pages ')}}
    </span><a @click="openBuyForm"><b-tag type="is-info" >{{$t('here')}}</b-tag></a>
    <hr>
    <span style="font-style: italic;">{{$t('This text was created automatically and may contain errors.')}}</span>
    <hr>
    <ul>
      <li
        ref="elements"
        v-for="(element, index) in content"
        @click="$emit('input', element.id)"
        :key="index"
        :class="[
          'browser-content-element',
          { 'is-highlighted': element.isSelected },
        ]"
      >
        <div
          v-if="
            element.hasTag && (tagMode === 'showtags' || tagMode === 'showtei')
          "
        >
          <b-field v-if="tagMode === 'showtags'" group-multiline>
            <span
              v-for="(text, index) in breakWhere(element.tags, element.content) " :key="index"
            >
              <span v-if="searchTag(element, text)">
                <a v-on:click="clickTag(element, text)">
                  <b-tooltip
                    position="is-right"
                    :label="toolTipLable(findTag(element, text))"
                  >
                    <b-tag id="tag" :type="tagColor(element, text)">
                      {{ text }}
                    </b-tag>
                  </b-tooltip>
                </a>
              </span>
              <span v-else>
                {{ text }}
              </span>
            </span>
          </b-field>
          <div v-if="tagMode === 'showtei'">
            <span v-html="teiHtml(element)"> </span>
          </div>
        </div>
        <div v-else>
          <span
            v-for="(segment, index) in element.segments" :key="index"
            :class="[
              'browser-content-label',
              { 'is-highlighted': segment.isMatch },
            ]"
            >{{ segment.string }}</span
          >
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import DetailContentDownload from "@/components/DetailContentDownload.vue";
import BuyFormModalVue from "./BuyFormModal.vue";


const { mapState, mapActions, mapGetters } = createNamespacedHelpers("browser");
export default {
  props: {
    content: {
      type: [Array],
      required: true,
    },
    selected: {
      type: [Number, String],
      default: null,
    },
  },
  watch: {
    selectedElement(element) {
      if (element !== null) {
        if (element.isFocused && element.eventSource) {
          this.scrollIntoView(this.elementIds.indexOf(element.id));
        }
      }
    },
  },
  computed: {
    ...mapState(["tagMode"]),
    selectedElements() {
      return this.content.filter((element) => element.isSelected);
    },
    selectedElement() {
      if (this.selectedElements.length === 0) {
        return null;
      } else {
        return this.selectedElements[0];
      }
    },
    elementIds() {
      return this.content.map((element) => element.id);
    },
  },
  methods: {
    scrollIntoView(index) {
      const element = this.$refs.elements[index];
      const container = this.$refs.container;

      if (element) {
        const method =
          typeof element.scrollIntoViewIfNeeded === "function"
            ? "scrollIntoViewIfNeeded"
            : typeof element.scrollIntoView === "function"
            ? "scrollIntoView"
            : null;

        if (method !== null) {
          element[method]({
            behavior: "smooth",
            block: "nearest",
            inline: "nearest",
          });
        }
      }
    },
    searchTag(element, text) {
      const found = element.tags.find(
        (x) =>
          x.length === text.length && x.offset === element.content.indexOf(text)
      );
      if (found) {
        return true;
      }
      return false;
    },
    findTag(element, text) {
      return element.tags.find(
        (x) =>
          x.length === text.length && x.offset === element.content.indexOf(text)
      );
    },
    cleanTag(attributes) {
      var temp = JSON.parse(JSON.stringify(attributes));
      delete temp.offset;
      delete temp.length;
      var tempArr = [];
      for (let [key, value] of Object.entries(temp)) {
        tempArr.push(` ${key} = ${value} `);
      }
      return tempArr;
    },
    tagColor(element, text) {
      return (
        "is-" +
        element.tags.find(
          (x) =>
            x.length === text.length &&
            x.offset === element.content.indexOf(text)
        ).name
      );
    },
    toolTipLable(tag) {
      var cleanedAttributes = this.cleanTag(tag.attributes);
      if (cleanedAttributes.length == 0) {
        return tag.name;
      } else {
        return "" + tag.name + " | " + cleanedAttributes;
      }
    },
    teiHtml(element) {
      var text = element.content;
      var tempText = element.content;
      for (var i = 0; i < element.tags.length; i++) {
        var tag = element.tags[i];
        var tagText = text.substr(tag.attributes.offset, tag.attributes.length);
        var cleanedAttributes = this.cleanTag(tag.attributes);
        tempText = tempText.replace(
          tagText,
          '<span class ="tag is-light has-text-' +
            tag.name +
            '"> &lt' +
            tag.name +
            " " +
            cleanedAttributes +
            " &gt</span>" +
            tagText +
            '<span class="tag is-light has-text-' +
            tag.name +
            '"> &lt/ ' +
            tag.name +
            "&gt </span>"
        );
      }
      return tempText;
    },
    intoPairs: (xs) => xs.slice(1).map((x, i) => [xs[i], x]),
    breakAt(places, str) {
      return this.intoPairs([0, ...places, str.length]).map(([a, b]) =>
        str.substring(a, b)
      );
    },
    breakWhere(words, str) {
      var temp = [];
      words = words.map((x) => {
        x.offset = x.attributes.offset;
        x.length = x.attributes.length;
        temp.push({ offset: x.attributes.offset, length: x.attributes.length });
      });
      var arr = this.breakAt(
        temp
          .slice(0)
          .sort(({ offset: o1 }, { offset: o2 }) => o1 - o2)
          .reduce(
            (a, { offset, length }) => [...a, offset, offset + length],
            []
          ),
        str
      );
      arr = arr.filter((item) => item);
      return Array.from(new Set(arr));
    },
    clickTag(element, text) {
      var type = element.tags.find(
        (x) =>
          x.length === text.length && x.offset === element.content.indexOf(text)
      ).name;
      console.log(type);
      let routeData = this.$router.resolve({
        name: "Tags",
        query: { v: text, type: type },
      });
      window.open(routeData.href, "_blank");
    },
    openBuyForm() {
       var modal = this.$buefy.modal.open({
        parent: this,
        component: BuyFormModalVue,
        canCancel: true,
        events: {
          closeModal: (value) => {
            modal.close();
          },
        },
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/colors.scss";

#tag {
  margin-right: 0.25rem;
  margin-left: 0.25rem;
}

.browser-content {
  padding: 0.75rem;
  height: 100%;
}

::-moz-selection {
  background: rgba($primary, 0.125);
}

.browser-content::selection {
  background: rgba($primary, 0.125);
}

.browser-content-element {
  padding: 0.25rem 0.75rem;
}

.browser-content-element:hover {
  background-color: rgba($primary, 0.075);
}

.browser-content-element.is-highlighted {
  font-weight: bold;
  background-color: rgba($primary, 0.225);
}

.browser-content-label.is-highlighted {
  font-weight: bold;
  border-bottom: 2px solid rgba($dark-red, 0.75);
}

.browser-content-element {
  cursor: pointer;
}
</style>
